module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"ACC Admin","username":"Username","password":"Password"}}')
  delete Component.options._Ctor
}
